function getCookie(name) {
  var matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

require(['jquery', 'scriptjs', 'selectize'], ($, $script) => {
  let map;

  $script(
    `https://maps.googleapis.com/maps/api/js?key=${serverData.googleMapsApiKey}&signed_in=true`,
    function() {
      var haightAshbury = { lat: 40.6925616, lng: -74.1748107 },
        customMapType = new google.maps.StyledMapType(
          [
            {
              elementType: 'geometry',
              stylers: [{ hue: '#ff4400' }, { saturation: -68 }, { lightness: -4 }, { gamma: 0.72 }]
            },
            { featureType: 'road', elementType: 'labels.icon' },
            {
              featureType: 'landscape.man_made',
              elementType: 'geometry',
              stylers: [{ hue: '#0077ff' }, { gamma: 3.1 }]
            },
            {
              featureType: 'water',
              stylers: [{ hue: '#00ccff' }, { gamma: 0.44 }, { saturation: -33 }]
            },
            { featureType: 'poi.park', stylers: [{ hue: '#44ff00' }, { saturation: -23 }] },
            {
              featureType: 'water',
              elementType: 'labels.text.fill',
              stylers: [{ hue: '#007fff' }, { gamma: 0.77 }, { saturation: 65 }, { lightness: 99 }]
            },
            {
              featureType: 'water',
              elementType: 'labels.text.stroke',
              stylers: [
                { gamma: 0.11 },
                { weight: 5.6 },
                { saturation: 99 },
                { hue: '#0091ff' },
                { lightness: -86 }
              ]
            },
            {
              featureType: 'transit.line',
              elementType: 'geometry',
              stylers: [{ lightness: -48 }, { hue: '#ff5e00' }, { gamma: 1.2 }, { saturation: -23 }]
            },
            {
              featureType: 'transit',
              elementType: 'labels.text.stroke',
              stylers: [
                { saturation: -64 },
                { hue: '#ff9100' },
                { lightness: 16 },
                { gamma: 0.47 },
                { weight: 2.7 }
              ]
            }
          ],
          { name: 'Custom Style' }
        ),
        customMapTypeId = 'custom_style';

      map = new google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: haightAshbury
      });

      map.mapTypes.set(customMapTypeId, customMapType);
      map.setMapTypeId(customMapTypeId);

      if (
        serverData.zipLocation === null ||
        serverData.zipLocation.lat === undefined ||
        serverData.zipLocation.lng === undefined
      ) {
        findGeolocation();
      } else {
        addMarker(serverData.zipLocation);
      }

      for (var organizationID in serverData.organizations) {
        for (var locationID in serverData.organizations[organizationID].locations) {
          var organizationLocation = serverData.organizations[organizationID].locations[locationID];
          organizationLocation.organizationName =
            serverData.organizations[organizationID].organizationName;
          if (organizationLocation.lat && organizationLocation.lng) {
            addMarker(organizationLocation, locationID, organizationID);
          }
        }
      }
      updateBounds();
    }
  );

  var typeEngine = $('#typeEngine').selectize();
  var city,
    $city = $('#city').selectize();
  var stateID,
    $stateID = $('#stateID').selectize({
      valueField: 'id',
      labelField: 'name',
      searchField: ['name']
    });

  function getStatesByCountryID(callback, value) {
    $.ajax({
      type: 'POST',
      url: serverData._uri + '/country/getStatesByCountryID/' + value + '/',
      data: {
        _method: 'ajax'
      },
      success: function(responce) {
        var states = [];
        for (var i = 0; i < responce.data.length; i++) {
          states.push({ id: responce.data[i].id, name: responce.data[i].name });
        }
        callback(states);
      },
      error: function() {
        callback();
      }
    });
  }

  var countryID,
    $countryID = $('#countryID').selectize({
      onChange: function(value) {
        stateID.clearOptions();
        if (!value.length) return;
        stateID.load(function(callback) {
          getStatesByCountryID(callback, value);
        });
      }
    });

  var mobileDevise = false;
  if (window.screen.width < 768 && window.screen.height < 768) {
    mobileDevise = true;
  }

  var mapBlock = document.getElementsByClassName('map-block'),
    searchBlockAdvanced = document.getElementsByClassName('search-block--advanced'),
    searchBlockResult = document.getElementsByClassName('search-block--result'),
    buttonAdvanced = document.getElementsByClassName('button-advanced');

  var geoLocation = {},
    markers = [];

  function changeAdvancedSearch() {
    var positionPage;
    if (typeof window.pageYOffset !== 'undefined') {
      positionPage = window.pageYOffset;
    } else {
      positionPage = document.documentElement.scrollTop;
    }

    if (positionPage <= 128 || !$(buttonAdvanced).hasClass('active')) {
      $(buttonAdvanced).toggleClass('active');
      $(searchBlockAdvanced).toggleClass('hide');
      var heightBlock = $(searchBlockAdvanced).outerHeight(true);

      if ($(searchBlockAdvanced).hasClass('hide')) {
        if (!mobileDevise) {
          searchBlockResult[0].style.marginTop = '178px';
        }
      } else {
        if (!mobileDevise) {
          searchBlockResult[0].style.marginTop = '20px';
        }
      }
    }
    if (positionPage > 128) {
      $('html, body').animate(
        {
          scrollTop: 128
        },
        400
      );
    }
  }

  $(buttonAdvanced).click(function() {
    changeAdvancedSearch();
  });

  function updateBlockPosition() {
    var positionPage;
    if (typeof window.pageYOffset !== 'undefined') {
      positionPage = window.pageYOffset;
    } else {
      positionPage = document.documentElement.scrollTop;
    }

    if (!mobileDevise) {
      if (positionPage <= 128) {
        mapBlock[0].style.top = (128 - positionPage).toString() + 'px';
        mapBlock[0].style.bottom = (115 + positionPage).toString() + 'px';
      } else {
        mapBlock[0].style.top = '0px';
        mapBlock[0].style.bottom = '243px';
      }
    }
  }

  $(window).scroll(function() {
    updateBlockPosition();
  });

  updateBlockPosition();

  function showLocations(organizationUnique) {
    var locationsBlock = $('#locations-' + organizationUnique).find('.location-block:not(:first)');
    var showAllLocations = $('#locations-' + organizationUnique).attr('show-locations');
    var textLocation = $('.organization-short-info--locations-all.' + organizationUnique + ' span');

    if (showAllLocations === 'true') {
      locationsBlock.addClass('hide');
      locationsBlock.find('.clearfix').addClass('hide');
      $('#locations-' + organizationUnique).attr('show-locations', false);
      textLocation.html('All Locations');
    } else {
      locationsBlock.removeClass('hide');
      locationsBlock.find('.clearfix').removeClass('hide');
      $('#locations-' + organizationUnique).attr('show-locations', true);
      textLocation.html('Hide Locations');
    }
  }

  $('.organization-short-info--locations-all').on('click', function showAllLocationsHandler(e) {
    showLocations(e.currentTarget.dataset.organization);
  });

  countryID = $countryID[0].selectize;
  stateID = $stateID[0].selectize;

  $('#searchForm').submit(e => {
    e.preventDefault();

    var searchForm = $(document.searchForm).serializeArray(),
      arrayType = ['services[]', 'typeAircraft[]'],
      linkArray = { link: '', distance: '', sort: '', services: '', typeAircraft: '' },
      zipCodeQueryEmpty = true;

    console.log('searchForm =>', searchForm);

    for (var i = 0; i < searchForm.length; i++) {
      if (searchForm[i].value.length > 0) {
        if (arrayType.indexOf(searchForm[i].name) > -1) {
          var type = searchForm[i].name.slice(0, searchForm[i].name.length - 2);
          linkArray[type] =
            linkArray[type] + (linkArray[type].length > 0 ? ',' : '') + searchForm[i].value;
        } else {
          linkArray.link = linkArray.link + searchForm[i].name + '=' + searchForm[i].value + ';';
        }
        if (searchForm[i].name === 'zipCodeQuery') {
          zipCodeQueryEmpty = false;
        }
      }
    }
    if (!$(searchBlockAdvanced).hasClass('hide')) {
      linkArray.link = linkArray.link + 'advanced=true;';
    }
    var link =
      linkArray.link +
      (linkArray.services.length > 0 ? 'services=' + linkArray.services + ';' : '') +
      (linkArray.typeAircraft.length > 0 ? 'typeAircraft=' + linkArray.typeAircraft + ';' : '');

    if (zipCodeQueryEmpty) {
      if (geoLocation.lat) {
        link = link + 'latitude=' + geoLocation.lat.toString().slice(0, 7) + ';';
      }
      if (geoLocation.lng) {
        link = link + 'longtitude=' + geoLocation.lng.toString().slice(0, 7) + ';';
      }
    }
    link = link + '/';

    location = location.origin + '/organizations/find/' + link;
  });

  var parseUrl = location.pathname.replace('/organizations/find/', '').split(';');
  if (parseUrl.indexOf('advanced=true') > -1) {
    changeAdvancedSearch();
  }

  function addMarker(organizationLocation, locationID, organizationID) {
    if (organizationLocation.lat && organizationLocation.lng) {
      var latLng = new google.maps.LatLng(
        parseFloat(organizationLocation.lat),
        parseFloat(organizationLocation.lng)
      );
      if (locationID) {
        var infoWindow = new google.maps.InfoWindow({
          content:
            '<div class="location' +
            locationID +
            '">' +
            '<b>' +
            organizationLocation.organizationName +
            '</b>' +
            '</br>' +
            organizationLocation.locationName +
            '</br>' +
            (organizationLocation.address ? organizationLocation.address + ', ' : '') +
            (organizationLocation.address_second
              ? organizationLocation.address_second + ', '
              : '') +
            (organizationLocation.city ? organizationLocation.city + ', ' : '') +
            (organizationLocation.stateName ? organizationLocation.stateName + ', ' : '') +
            (organizationLocation.zip ? organizationLocation.zip + ', ' : '') +
            (organizationLocation.countryName ? organizationLocation.countryName : '') +
            '</div>'
        });
        var marker = new google.maps.Marker({
          locationID: locationID,
          position: latLng,
          map: map,
          icon: '../../../public/images/marker-plane.png',
          title: organizationLocation.locationName
        });
        marker.addListener('click', function() {
          infoWindow.open(map, marker);
          window.location.href = '#';
          window.location.href = '#search-result-organization-' + organizationID;
        });
      } else {
        var marker = new google.maps.Marker({
          position: latLng,
          map: map,
          icon: '../../../public/images/marker-place.png',
          title: 'Your Location'
        });
      }
      markers.push(marker);
    }
  }

  function findGeolocation() {
    // Try HTML5 geolocation.
    var pos = {};
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(position) {
        console.log('i here ', geoLocation);
        geoLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        addMarker(geoLocation);
        updateBounds();
        var userPosition = 0;

        if (
          serverData.searchRequest.latitude &&
          serverData.searchRequest.latitude === geoLocation.lat.toString().slice(0, 7)
        ) {
          userPosition = userPosition + 1;
        }
        if (
          serverData.searchRequest.longtitude &&
          serverData.searchRequest.longtitude === geoLocation.lng.toString().slice(0, 7)
        ) {
          userPosition = userPosition + 1;
        }

        if (userPosition !== 2 && !serverData.searchRequest.zipCodeQuery) {
          $('#searchForm').submit();
        }
      });
    }
  }

  function updateBounds() {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].position);
    }

    map.fitBounds(bounds);
    if (markers.length < 2) {
      map.setZoom(16);
    }

    getDistance();
  }

  $('.location-block')
    .mouseenter(function(event) {
      var locationID = $(event.currentTarget).attr('location-id');

      for (var i = 0; i < markers.length; i++) {
        if (markers[i].locationID === locationID) {
          markers[i].setAnimation(google.maps.Animation.BOUNCE);
        }
      }
    })
    .mouseleave(function(event) {
      var locationID = $(event.currentTarget).attr('location-id');
      for (var i = 0; i < markers.length; i++) {
        if (markers[i].locationID === locationID) {
          markers[i].setAnimation(null);
        }
      }
    });

  function getDistance() {
    let markersLocations = markers.filter(function(marker) {
      return marker.locationID !== undefined;
    });
    let markersPlace = markers.filter(function(marker) {
      return marker.locationID === undefined;
    });

    if (markersPlace.length === 1) {
      var latPlace = markersPlace[0].position.lat(),
        lngPlace = markersPlace[0].position.lng();
      for (var i = 0; i < markersLocations.length; i++) {
        var latLocation = markersLocations[i].position.lat(),
          lngLocation = markersLocations[i].position.lng();
        var distance =
          3959 *
          Math.acos(
            Math.cos(latPlace * (Math.PI / 180)) *
              Math.cos(latLocation * (Math.PI / 180)) *
              Math.cos(lngLocation * (Math.PI / 180) - lngPlace * (Math.PI / 180)) +
              Math.sin(latPlace * (Math.PI / 180)) * Math.sin(latLocation * (Math.PI / 180))
          );
        $('.location-' + markersLocations[i].locationID + ' .statistic-distance').html(
          parseInt(distance) + ' mi'
        );
      }
    }
  }

  function organizationAddEventButton(organizationUnique) {
    var organizationsDataForCalendars =
        serverData.organizationsDataForCalendars &&
        serverData.organizationsDataForCalendars !== undefined
          ? serverData.organizationsDataForCalendars
          : [],
      calendarView = 'month',
      link = '';

    var organizationsCalendars = JSON.parse(getCookie('organizationsCalendars') || '{}');

    for (var i = 0; i < organizationsDataForCalendars.length; i++) {
      if (organizationsDataForCalendars[i].unique === organizationUnique) {
        if (organizationsCalendars['organization-' + organizationsDataForCalendars[i].id]) {
          calendarView =
            organizationsCalendars['organization-' + organizationsDataForCalendars[i].id];
          if (calendarView === 'pilot') {
            calendarView = 'report';
          }
        }
        break;
      }
    }

    if (organizationUnique) {
      var date = new Date(),
        dateStart = new Date(),
        hours = date.getHours(),
        minutes = date.getMinutes();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      var unixDate = parseInt(
        date.getTime() / 1000 -
          date.getTimezoneOffset() * 60 -
          parseInt(serverData.timeZoneOffset, 10),
        10
      );

      if (minutes < 30) {
        minutes = 30;
      } else {
        minutes = 0;
        hours = hours + 1;
      }
      dateStart.setHours(hours);
      dateStart.setMinutes(minutes);
      dateStart.setSeconds(0);
      var unixDateStart = parseInt(dateStart.getTime() / 1000, 10);

      link =
        serverData._uri +
        '/org/' +
        organizationUnique +
        '/calendar/' +
        calendarView +
        '/#/!?day=' +
        unixDate +
        '&org=' +
        organizationUnique +
        '&action=event-add&startTime=' +
        unixDateStart;
      return link;
    }
  }
  var organizationAddEventButtonArray = $('.organization-add-event-button');
  for (var i = 0; i < organizationAddEventButtonArray.length; i++) {
    var organizationUnique = $(organizationAddEventButtonArray[i]).attr('organizationUnique');
    $(organizationAddEventButtonArray[i]).attr(
      'href',
      organizationAddEventButton(organizationUnique)
    );
  }
});
